import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import api from "../../../../services/api";
import placeholder from "../../../../assets/images/icons/placeholder.png";
import { MdEdit } from "react-icons/md";
import TableColumn from "../../../TableColumn/TableColumn";
import EmptyState from "../../../EmptyList/EmptyState";
import Skeleton from "../../../Skeleton/Skeleton";
import { colors } from "../../../../styles/tokens";

export default function ExpiredOffers() {
    const navigate = useNavigate();

    const [sortBy, setSortBy] = useState(null);
    const [sortDirection, setSortDirection] = useState("desc");
    const [isLoading, setIsLoading] = useState(true);
    const [totalPages, setTotalPages] = useState(0);
    const [currentPage, setCurrentPage] = useState(
        Number(localStorage.getItem("ListCurrentOngoingOffer")) || 1
    );
    const records = 10;

    const sortableColumns = ["Date", "Name", "Birth Day", "Gender"];
    const [listOffers, setListOffers] = useState([]);

    const columns = [
        "Image",
        "Venue",
        "Title",
        "Approved By",
        "Description",
        "Redeemed",
    ];

    const actions = [
        {
            label: <MdEdit size={30} color={colors.primary} />,
            onClick: (rowData) => {
                navigate(`/offers/${rowData?.id}/edit`, {
                    state: {
                        offerData: JSON.parse(rowData.offerData)
                    }
                });
            },
        },
    ];

    useEffect(() => {
        const fetchData = async (page) => {
            setIsLoading(true);
            try {
                const response = await api.get(`offers/search`, {
                    params: {
                        page: page,
                        records: records,
                        sort_column: sortBy,
                        sort: sortDirection,
                        status: 'EXPIRED'
                    },
                });

                const itemsTableColumns = response.data.data.map((offers) => ({
                    id: offers._id,
                    Image: (
                        <img
                            className="rounded"
                            style={{ height: 40, width: 40 }}
                            src={
                                !(offers?.image_url) || offers.image_url.includes('undefined')
                                    ? placeholder
                                    : offers.image_url
                            }
                            alt={offers.subject}
                        />
                    ),
                    Venue: offers?.venue_details?.name,
                    Title: offers.subject,
                    'Approved By': offers.approved_by || '-',
                    Description: (
                        <div style={{
                            maxWidth: '300px',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis'
                        }}>
                            {offers.description}
                        </div>
                    ),
                    // offerData: JSON.stringify(offers),
                    Redeemed: (
                        <span>
                            <Link
                                to={`/offers/${offers._id}/redeemed`}
                                className="number-pill"
                            >
                                {offers.total_redeemed}
                            </Link>{" "}
                        </span>
                    )
                }));

                setListOffers(itemsTableColumns);
                setTotalPages(response.data.total);
            } catch (error) {
                console.log(error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchData(currentPage);
    }, [sortBy, sortDirection, currentPage]);

    const sortColumnsMapping = {
        Subject: "subject",
        Date: "expiration_date",
    };

    const handleSort = (columnName) => {
        const backendColumnName = sortColumnsMapping[columnName];
        if (sortBy === backendColumnName) {
            setSortDirection(sortDirection === "asc" ? "desc" : "asc");
        } else {
            setSortBy(backendColumnName);
            setSortDirection("asc");
        }
    };

    useEffect(() => {
        const storedPage = localStorage.getItem("ListCurrentOngoingOffer");
        setCurrentPage(Number(storedPage) || 1);
    }, []);

    const handlePageChange = (page) => {
        setCurrentPage(page);
        localStorage.setItem("ListCurrentOngoingOffer", page);
    };

    return (
        <>
            {isLoading ? (
                <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                    <Skeleton type="row" />
                    <Skeleton type="row" />
                    <Skeleton type="row" />
                    <Skeleton type="row" />
                </div>
            ) : listOffers.length === 0 ? (
                <EmptyState
                    title="No Expired Offers"
                    message="There are no expired offers at the moment."
                />
            ) : (
                <TableColumn
                    title="Expired Offers"
                    columns={columns}
                    data={listOffers}
                    // actions={actions} // uncomment if you want edit actions
                    isLoading={isLoading}
                    sortableColumns={sortableColumns}
                    hasHeader={false}
                    hasExport={false}
                    hasSearch={false}
                    dateColumnKeys={['Valid Until']}
                    totalPages={totalPages}
                    currentPage={currentPage}
                    onPageChange={handlePageChange}
                    records={records}
                    onSort={handleSort}
                />
            )}
        </>
    );

}
